import { useCallback, useMemo } from 'react';

import { RocketOutlined, CrownOutlined, MenuOutlined } from '@ant-design/icons';
import { Space, Button, Badge, Tooltip, Dropdown } from 'antd';
import { getMSALInstance } from '~/services/msal';
import { useSubmit } from '@remix-run/react';
import { useApplicationContext } from '../ApplicationContext';
import { useActivateSubscriptionDialog } from '../ActivateSusbcriptionModal';
import { useGetSubscriptionDialog } from '../GetSubscriptionModal';
import { useDisplayTokens } from '~/hooks';

export function useSignOutWithMsal() {
    const applicationContext = useApplicationContext();
    const submit = useSubmit();
    const handleSignOut = useCallback(async () => {
        const msalClient = getMSALInstance();
        await msalClient.initialize();
        await msalClient.clearCache();
        msalClient.setActiveAccount(null);
        submit(null, {
            method: 'POST',
            action: applicationContext?.isIframe
                ? '/iframe?index'
                : '/office?index',
        });
    }, [submit, applicationContext]);

    return handleSignOut;
}
